import PropTypes from "prop-types";

import FnrConfirmCancel from "UI/FnrConfirmCancel/FnrConfirmCancel";

import useFPTrial from "splashes/SplashHooks/useFPTrial";

const errorText =
  "Something went wrong with starting that trial. Please try again or contact support.";

const FlocknotePeopleTrialButtons = ({ successCallback, variant = "cta" }) => {
  const [{ isLoading, hasError, isSuperAdmin }, { activateFP, learnMoreFP }] =
    useFPTrial(successCallback);

  const getConfirmText = () => {
    if (variant === "cta2") {
      return "Upgrade Today";
    }

    return "Upgrade Now";
  };

  return (
    <FnrConfirmCancel
      error={hasError}
      errorText={errorText}
      variant={variant}
      confirm={activateFP}
      confirmText={getConfirmText()}
      cancelText="Learn More"
      cancel={learnMoreFP}
      isLoading={isLoading}
      data-cy="Splashes_FlockNotePeopleButtons"
      hideConfirmButton={!isSuperAdmin}
    />
  );
};

FlocknotePeopleTrialButtons.propTypes = {
  successCallback: PropTypes.func,
  variant: PropTypes.oneOf(["cta", "cta2"]),
};

export default FlocknotePeopleTrialButtons;
